import React from "react";
import locale from "@bonliva-crm/locale";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Body } from "@components";
import { ThemeType } from "@theme";
import { ExpDelete } from "./ExpDelete";
import { OutlinedInput } from "./OutlinedInput";

type ExpTopPanelProp = {
  certifiedPath: string;
  certifiedFromTxt: string;
  onDeleteClick: () => void;
  withPrescriptionCode?: boolean;
};

export function ExpTopPanel(props: ExpTopPanelProp) {
  const { certifiedPath, certifiedFromTxt, onDeleteClick } = props;

  const classes = useStyles({});

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={6} md={4} lg={2} container alignItems="center">
        <Body>{certifiedFromTxt}</Body>
      </Grid>

      <Grid item xs={6} md={8} lg={4} className={classes.inputs}>
        <OutlinedInput name={`${certifiedPath}`} label={locale.CertifiedFrom} />

        {props.withPrescriptionCode && (
          <OutlinedInput name="prescriptionCode.code" label={locale.PrescriptionCode} />
        )}
      </Grid>

      <ExpDelete onDeleteClick={onDeleteClick} />
    </Grid>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  inputs: {
    ...theme.mixins.childrenMarginRight(8)
  }
}));
